// Auto-generated file - do not edit
export const APP_VERSION: string = '1.2026.1020.01';
export const APP_COMMIT: string = '4aa351f1325f69e5d0deba8ac62c3b5d0ffa781f';
export const APP_COMMIT_SHORT: string = '4aa351f1';
